import About1 from "../components/About1";
import Features from "../components/Features";
import Testimonials from "../components/testimonials";

const About = () => {
  return (
    <div>
      <About1 />
      <Features />
      <Testimonials />
    </div>
  );
};

export default About;
